import { useEffect, useState } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import * as translator from "../../../../utils/translator"
import "./ChooseTreatmentReorder.css"
import ReorderProductCard from "../ReorderProductCard/ReorderProductCard";
import DrugSubscription from "../../../ChooseTreatmentVariants/components/DrugSubscription/DrugSubscription";
import SubmitButton from "../../../../components/SubmitButton/SubmitButton";
import { trackReorderFlowEnd, trackReorderFlowScreen } from "../../ReorderTrackingManager";
import { calcLegacyProductPrice, getLegacyPlanDiscount, getLegacyReorderTotal, getPreselectedReorderPrice, showsWlReorderOffer } from "../../reorderPrices";
import { useReorderCartSubmit } from "./useReorderCartSubmit";
import WlReorderPlanScreen from "../WlReorderPlanScreen/WlReorderPlanScreen";
import { WL_REORDER_TEST_NAME } from "../../../../utils/wlReorderSubscriptionExperiment";





const ChooseTreatmentReorder = () => {
  const [searchParams] = useSearchParams();
  const [submitButtonLoading,setSubmitButtonLoading] = useState<boolean>(false);
  const { reorderData, language, country, setStickyNotificationDetails,setShowSubscriptionModal,getMaxDiscountOfSubscriptionPlans,setHeaderStep, wlReorderVariant, setWlReorderPage } = useOutletContext<any>(); //context of ReorderLayout
  const productItems = reorderData.orderProductItems
  const isMultipleProductOrder = productItems.length > 1;
  // WL test arms B and C; everyone else gets the legacy screen.
  const showWlOffer = showsWlReorderOffer(reorderData, wlReorderVariant);

  const defaultSelectedPlanID = isMultipleProductOrder ? null : productItems[0]?.subscriptionPlans[productItems[0].product_item_id][0]?.id;
  const [selectedSubscriptionPlanID,setSelectedSubscriptionPlanID] = useState<number | string | null>(defaultSelectedPlanID);
  const productItemSubscriptionPlans = isMultipleProductOrder ? null : productItems[0]?.subscriptionPlans || null;
  const onlyPrescription = reorderData.isOnlyPrescription;
  const discount = !isMultipleProductOrder ? getMaxDiscountOfSubscriptionPlans() : 0;
  const { saveReorderToCart, goToNextStep, showSubmitError } = useReorderCartSubmit(reorderData, country, language, setStickyNotificationDetails);

  useEffect(()=>{
    setHeaderStep("Treatment");
    trackReorderFlowScreen(reorderData.trackingContext, getPreselectedReorderPrice(reorderData, country, wlReorderVariant), wlReorderVariant);

    if(!showWlOffer && !isMultipleProductOrder && productItemSubscriptionPlans[productItems[0].product_item_id]?.length){
      setShowSubscriptionModal(true); //if there are plans to the product show the subscription modal
    }

  },[])

  const onSubmit = () => {
    const isOneTime = selectedSubscriptionPlanID === "one-time" || !selectedSubscriptionPlanID;
    trackReorderFlowEnd(reorderData.trackingContext, getLegacyReorderTotal(reorderData, country, selectedSubscriptionPlanID), wlReorderVariant, !isOneTime);

    saveReorderToCart({
      subscriptionPlanID: isOneTime ? null : selectedSubscriptionPlanID,
      appliedSubscriptionDiscount: isMultipleProductOrder ? 0 : getLegacyPlanDiscount(reorderData, selectedSubscriptionPlanID),
      isSftd: selectedSubscriptionPlanID === "one-time",
      // Arm A also uses this screen; keep its arm for Paid Order.
      experiments: wlReorderVariant ? { [WL_REORDER_TEST_NAME]: wlReorderVariant } : undefined,
    })
    .then(goToNextStep)
    .catch(showSubmitError)
    .finally(() => {
      setSubmitButtonLoading(false);
    });
  }

  if (showWlOffer) {
    return (
      <WlReorderPlanScreen
        reorderData={reorderData}
        variant={wlReorderVariant}
        searchParams={searchParams}
        country={country}
        language={language}
        setStickyNotificationDetails={setStickyNotificationDetails}
        setWlReorderPage={setWlReorderPage}
      />
    );
  }

  return (
    <>
      {reorderData.orderProductItems.map((productItem: any) => (

        <div key={productItem.product_item_id} id="reorder-product-cards-container" >
          <ReorderProductCard
            productImgSrc={productItem.base_path + "/" + productItem.name}
            productPrice={calcLegacyProductPrice(productItem, onlyPrescription, country)}
            productQuantity={productItem.custom_quantity_title}
            productTitle={productItem.title}
            isProductInStock={productItem.isAvailableForReorder}
            currencyRate={reorderData.currencyRate}
          />

          {/* Choose treatment title */}
          {!isMultipleProductOrder && productItemSubscriptionPlans[productItem.product_item_id]?.length ? (
            <h1>
              {translator.translate(language, "reorder", "ChooseTreatmentReorder/ct_plan")}
            </h1>
          ) : null}

          {/* Treatment plans disclaimer text */}
          {discount > 0 ? (
            <p className="treatment-plan-disclaimer">
              {translator
                .translate(language, "reorder", "ChooseTreatmentReorder/treatment-plan-disclaimer")
                .replace("::discount", getMaxDiscountOfSubscriptionPlans())}
            </p>
          ) : null}

          <div className="treatment-plans-container">
            {!isMultipleProductOrder && country.toLowerCase() === "de" &&
            productItemSubscriptionPlans[productItem.product_item_id]?.length ? (
              <DrugSubscription
                showDeliveryErrorMessage={''}
                setShowDeliveryMessage={() => {}}
                selectedSubscriptionPlanID={selectedSubscriptionPlanID}
                setSelectedSubscriptionPlanID={setSelectedSubscriptionPlanID}
                productItemSubscriptionPlans={productItemSubscriptionPlans}
                selectedPackItemObject={productItem}
                selectedPackItem={productItem.product_item_id}
                productName={productItem.title}
                productQuantity={productItem.quantity}
              />
            ) : null}
          </div>
        </div>
      ))}
      {/* Different plan link */}
      <a
            className="change-treatment-link"
            href={`/select_treatment/${country}/${language}/${reorderData.catalogMention}?${searchParams.toString()}`}>
            {translator.translate(language, "reorder", "ChooseTreatmentReorder/different_treatment")}
      </a>
      <SubmitButton
          id="reorder-submit"
          className="reorder-submit"
          language={language}
          placeholder={translator.translate(language, "reorder", "ChooseTreatmentReorder/submitButtonText")}
          showArrow={true}
          width={"auto"}
          onSubmit={onSubmit}
          loading={submitButtonLoading}
        />
    </>
  );
};

export default ChooseTreatmentReorder;
